module.exports = __webpack_public_path__ + "static/media/matching.5ea32845.gif";